module.exports = "/_next/static/images/f49e4b035880acc100dd98bd41057eb1-nubank-outdoor-md@2x.jpg.webp";